import React from 'react';
import classNames from 'classnames';

import { onOpenGenericLogFeedbackModal } from '../../../helpers/selectionOverlayUtils';

import { SelectionProvider } from '../../../contexts/selectionContext';

import BodyContentField from '../BodyContentField/BodyContentField';
import LogFeedbackTrigger from '../../../components/LogFeedbackTrigger/LogFeedbackTrigger';
import FreeformContentField from '../FreeformContentField/FreeformContentField';
import MultiSelectContentPiece from '../MultiSelectContentPiece/MultiSelectContentPiece';
import SingleSelectContentPiece from '../SingleSelectContentPiece/SingleSelectContentPiece';

const MessageContentForm = ({
    formData,
    setFormData = () => {},
    editable,
    errorFormFields = {},
    setErrorFormFields = () => {},
    bodyTypeFormFieldsCount,
    feedbackAllowed = false,
    messageId,
}) => {
    return (
        <>
            {formData?.map(({ id, action_type, label, options, value }, index) => {
                const formFieldContainerClassName = classNames({
                    'pb-6': index <= bodyTypeFormFieldsCount - 1,
                    'border-b-1 border-neutral-200': index === bodyTypeFormFieldsCount - 1,
                    'pt-6': index === bodyTypeFormFieldsCount && index > 0,
                    'pb-4': index >= bodyTypeFormFieldsCount && index < formData.length - 1,
                });

                const state = !editable ? 'disabled' : errorFormFields[id] ? 'error' : 'default';

                let logFeedbackTrigger = null;
                if (action_type !== 'freeform') {
                    logFeedbackTrigger = feedbackAllowed && (
                        <LogFeedbackTrigger
                            target="inbox_message"
                            targetId={messageId}
                            contentPieceId={id}
                            type="button_icon"
                            onOpenModal={onOpenGenericLogFeedbackModal}
                        />
                    );
                }

                return (
                    <div key={id} className={formFieldContainerClassName}>
                        {action_type === 'body' && (
                            <BodyContentField
                                value={value}
                                feedbackAllowed={feedbackAllowed}
                                logFeedbackTrigger={logFeedbackTrigger}
                            />
                        )}

                        {action_type === 'freeform' && (
                            <FreeformContentField
                                value={value}
                                label={label}
                                state={state}
                                id={id}
                                setFormData={setFormData}
                                setErrorFormFields={setErrorFormFields}
                                contentPieceId={id}
                                feedbackAllowed={feedbackAllowed}
                                feedbackTarget="inbox_message"
                                feedbackTargetId={messageId}
                            />
                        )}

                        {action_type === 'single-select' && (
                            <SingleSelectContentPiece
                                id={id}
                                label={label}
                                state={state}
                                value={value}
                                options={options}
                                editable={editable}
                                logFeedbackTrigger={logFeedbackTrigger}
                                setFormData={setFormData}
                                setErrorFormFields={setErrorFormFields}
                            />
                        )}

                        {action_type === 'multi-select' && (
                            <MultiSelectContentPiece
                                id={id}
                                label={label}
                                value={value}
                                options={options}
                                editable={editable}
                                setFormData={setFormData}
                                logFeedbackTrigger={logFeedbackTrigger}
                            />
                        )}
                    </div>
                );
            })}
        </>
    );
};

const WrappedMessageContentForm = (props) => (
    <SelectionProvider>
        <MessageContentForm {...props} />
    </SelectionProvider>
);

export default WrappedMessageContentForm;
